import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectDarkMode } from "../../../app/store/slices/uiSlice";

const TabbedForm = ({ formFields, formData, handleFormChange, renderFormField, tabsConfig, initialTab, activeTab: externalActiveTab, setActiveTab: externalSetActiveTab, disabledTabs = [] }) => {
  const darkMode = useSelector(selectDarkMode);
  const safeFormFields = Array.isArray(formFields) ? formFields : [];

  const [internalActiveTab, setInternalActiveTab] = useState(initialTab || Object.keys(tabsConfig || {})[0] || "");

  const activeTab = externalActiveTab !== undefined ? externalActiveTab : internalActiveTab;
  const setActiveTab = externalSetActiveTab || setInternalActiveTab;

  const getFieldsBySection = (section) => safeFormFields.filter((f) => f.section === section);

  const isTabDisabled = (sectionKey) => disabledTabs.includes(sectionKey);

  if (!tabsConfig || Object.keys(tabsConfig).length === 0) {
    return <div>No tabs configured.</div>;
  }

  return (
    <div className="Form_tabs">
      <div className={`border-b mb-8 ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
        <nav className="-mb-px flex gap-2 sm:gap-5 flex-wrap flex-col sm:flex-row">
          {Object.keys(tabsConfig).map((sectionKey) => {
            const disabled = isTabDisabled(sectionKey);
            return (
              <button
                key={sectionKey}
                type="button"
                onClick={() => !disabled && setActiveTab(sectionKey)}
                disabled={disabled}
                className={`flex items-center space-x-2 sm:py-2 py-1 px-1 border-b-2 font-medium text-sm ${
                  disabled
                    ? "border-transparent text-gray-300 cursor-not-allowed opacity-50"
                    : activeTab === sectionKey
                      ? "border-[#4057FE] text-[#4057FE]"
                      : darkMode
                        ? "border-transparent text-gray-400 hover:text-[#4057FE] hover:border-[#4057FE] hover:opacity-70 transition-all duration-200 ease-in-out"
                        : "border-transparent text-[#74777F] hover:text-[#4057FE] hover:border-[#4057FE] hover:opacity-70 transition-all duration-200 ease-in-out"
                } `}
              >
                {tabsConfig[sectionKey].icon && <span>{tabsConfig[sectionKey].icon}</span>}
                <span>{tabsConfig[sectionKey].label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      <div className="grid sm:grid-cols-2 grid-cols-1 gap-3 sm:gap-6">
        {getFieldsBySection(activeTab).map((field) => (
          <div key={field.name} className={field.fullWidth ? "col-span-1 sm:col-span-2 " : ""}>
            {renderFormField(field)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabbedForm;
